module.exports = __webpack_public_path__ + "static/media/lucian.e4df5fbf.png";